import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { PageHeader } from "@/components/layout/PageHeader";
import { cn } from "@/lib/utils";
import { t } from "@/lib/i18n";
import { UsersPage } from "./settings/Users";
import { LicensePage } from "./settings/License";
import { RetentionPage } from "./settings/Retention";
import { PayloadsPage } from "./settings/Payloads";
import { UpdatesPage } from "./settings/Updates";
import { SsoPage } from "./settings/Sso";
import { MetabasePage } from "./settings/Metabase";
import { IntegrationsPage } from "./settings/Integrations";
import { SmtpPage } from "./settings/Smtp";
import { BerichtPage } from "./settings/Bericht";

const SUB_NAV = [
  { to: "benutzer", label: t("Benutzer") },
  { to: "sso", label: t("Single Sign-On") },
  { to: "lizenz", label: t("Lizenz") },
  { to: "retention", label: t("Retention") },
  { to: "payloads", label: t("Payloads") },
  { to: "email", label: t("E-Mail") },
  { to: "bericht", label: t("Bericht") },
  { to: "metabase", label: "Metabase" },
  { to: "anbindung", label: t("Anbindung") },
  { to: "updates", label: t("Updates") },
];

export function SettingsPage() {
  return (
    <div>
      <PageHeader
        title={t("Einstellungen")}
        description={t("Benutzer, Lizenz, Retention und Updates")}
      />
      <SubNav />
      <Routes>
        <Route index element={<Navigate to="benutzer" replace />} />
        <Route path="benutzer" element={<UsersPage />} />
        <Route path="sso" element={<SsoPage />} />
        <Route path="lizenz" element={<LicensePage />} />
        <Route path="retention" element={<RetentionPage />} />
        <Route path="payloads" element={<PayloadsPage />} />
        <Route path="email" element={<SmtpPage />} />
        <Route path="bericht" element={<BerichtPage />} />
        <Route path="metabase" element={<MetabasePage />} />
        <Route path="anbindung" element={<IntegrationsPage />} />
        <Route path="updates" element={<UpdatesPage />} />
      </Routes>
    </div>
  );
}

function SubNav() {
  return (
    // Mobil: horizontal scrollbare Leiste statt Umbruch/Overflow; Scrollbar versteckt.
    <div className="flex gap-1 overflow-x-auto border-b border-border px-3 py-2 [scrollbar-width:none] md:px-6 [&::-webkit-scrollbar]:hidden">
      {SUB_NAV.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            cn(
              "shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-xs font-medium transition-colors md:py-1",
              isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:bg-muted",
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
    </div>
  );
}
